export default "__VITE_ASSET__BCVKS6F7__"